import { PopularQueriesContent } from '@models';
import { searchService } from '@services';
import { BaseContentComponent } from '../base-content.component';
import defaultHtml from './popular-queries-content.component.hbs';

export class PopularQueriesComponent extends BaseContentComponent<PopularQueriesContent> {
    protected override customTemplatePropertyName = 'popularQueriesContent';
    protected override defaultHtml = defaultHtml;

    protected getContentHtml(template: HandlebarsTemplateDelegate): string {
        if (!this.data?.items.length) {
            return '';
        }

        const html = template(this.data);

        return html;
    }

    protected bindChildElements(): void {
        this.shadowRoot?.querySelectorAll('[hawksearch-query]').forEach((e) => {
            e.addEventListener('click', (event: Event) => {
                event.preventDefault();

                const element = event.currentTarget as HTMLElement;
                const query = element.getAttribute('hawksearch-query');

                if (query) {
                    searchService.query(query);
                }
            });
        });
    }
}
